import React from "react";
import { CreateZoneStage1Page } from "./stage1";
import { useSearchParams } from "react-router-dom";
import { CreateZoneStage2Page } from "./stage2";


export const CreateZonePage: React.FC = () => {

  const [searchParams] = useSearchParams();

  const stage = searchParams.get('stage');

  return (
    <React.Fragment>
      {stage ===  '2' ? (
        <CreateZoneStage2Page />
      ) : (
        <CreateZoneStage1Page />
      )}
    </React.Fragment>
  );
};